module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_8.1a45b007.pdf";